/**
 *
 * MetricBar
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 120px;
  @media screen and (max-width: 415px) {
    width: 100%;
  }
`;
const BaseBar = styled.div`
  height: 6px;
  width: 100%;
  background: #ebebeb;
  border-radius: 2px;
  overflow: hidden;
`;
const Bar = styled.div`
  background: #2a3795;
  height: 100%;
  border-radius: 2px;
  width: ${props => `${props.percentage}%`};
`;

function MetricBar({ percentage }) {
  return (
    <Container>
      <BaseBar>
        <Bar percentage={percentage} />
      </BaseBar>
    </Container>
  );
}

MetricBar.propTypes = {
  percentage: PropTypes.number
};

export default MetricBar;
